import { useGetCredits } from './use-get-credits';

export const useCreditsCurrentPage = (): number => {
  const creditsQuery = useGetCredits();

  return creditsQuery?.data?.pagination.currentPage
    ? creditsQuery.data.pagination.currentPage - 1
    : 0;
};
